/**
 * LevNutri — Redefinição de senha via link enviado por e-mail (rota pública /reset-senha/TOKEN)
 */

import React, { useState } from 'react';
import { passwordResetService } from '../services/api';
import './Login.css';
import { Ico } from './ui/Ico';

const LOGO_URL = 'https://www.levnutri.com/assets/logo.png';

function ResetSenha({ token }) {
  const [senha, setSenha]       = useState('');
  const [confirma, setConfirma] = useState('');
  const [error, setError]       = useState('');
  const [ok, setOk]             = useState(false);
  const [loading, setLoading]   = useState(false);
  const [logoError, setLogoError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (senha.length < 8)      { setError('A senha deve ter pelo menos 8 caracteres.'); return; }
    if (senha !== confirma)    { setError('As senhas não conferem.'); return; }
    setLoading(true);
    try {
      await passwordResetService.reset(token, senha);
      setOk(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            {!logoError ? (
              <img src={LOGO_URL} alt="LevNutri" style={{ height: '72px', objectFit: 'contain' }} onError={() => setLogoError(true)} />
            ) : (
              <h1 className="login-logo-text">LevNutri</h1>
            )}
          </div>
          <p className="login-subtitle">Criar nova senha</p>
        </div>

        {ok ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}><Ico e="✅" /></div>
            <p style={{ color: '#2f5236', fontWeight: 600, marginBottom: '1.25rem' }}>
              Senha redefinida com sucesso!
            </p>
            <a href="/" className="login-button" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', lineHeight: '1.4' }}>
              Ir para o login →
            </a>
          </div>
        ) : (
          <>
            {error && (
              <div className="login-error">
                <span className="error-icon"><Ico e="⚠" /></span>
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="senha">Nova senha</label>
                <input
                  id="senha" type="password" value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="mínimo 8 caracteres" required minLength={8}
                  disabled={loading} autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirma">Confirmar nova senha</label>
                <input
                  id="confirma" type="password" value={confirma}
                  onChange={(e) => setConfirma(e.target.value)}
                  placeholder="repita a senha" required minLength={8}
                  disabled={loading} autoComplete="new-password"
                />
              </div>
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? <span className="button-spinner" /> : <span>Salvar nova senha</span>}
              </button>
            </form>
          </>
        )}
      </div>

      <div className="login-credits">
        <p>© {new Date().getFullYear()} LevNutri · Todos os direitos reservados</p>
      </div>
    </div>
  );
}

export default ResetSenha;
